var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongFasongMianxing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.863 4.276a1 1 0 00-1.252-1.253L2.259 5.946a1 1 0 00-.33 1.732L4.926 10.1l3.21-2.876a.433.433 0 11.613.613l-2.863 3.246 2.323 2.874a1 1 0 001.732-.33l2.922-9.352z",
    fill: "#4C6AFF"
  })));
}
export default __webpack_public_path__ + "static/tongyong_fasong_mianxing.3f9e7dd6.svg";
export { SvgTongyongFasongMianxing as ReactComponent };